export const PREFIX = `You are a helpful AI assistant.`;
export const SUFFIX = ``;
